import Utils from './utils.js'

export default {

  init() {

    this.initHeroParallax();
    this.initDesignParallax();

  },

  initDesignParallax() {

    if ( document.querySelector( '[data-parallax]' ) == null ) {
      return;
    }

    this.designParallax = this.designParallax.bind( this );
    this.designsEl = document.querySelectorAll( '[data-parallax]' );

    // window.onLoad = this.designParallax();
    document.addEventListener( 'scroll', this.designParallax );

  },

  initHeroParallax() {

    this.heroEl = document.querySelector( '.js-opacity-parallax' );

    if ( this.heroEl == null ) {
      return;
    }

    this.heroParallax = this.heroParallax.bind( this );
    this.heroHeight = this.heroEl.offsetHeight + this.heroEl.style.marginBottom + this.heroEl.style.marginTop;

    document.addEventListener( 'scroll', this.heroParallax );

  },

  heroParallax() {

    if ( Utils.scrollY > this.heroHeight ) {
      return;
    }

    this.heroEl.style.opacity = ( ( ( this.heroHeight - window.scrollY ) / this.heroHeight ) * 0.8 ) + 0.2

  },

  designParallax() {

    const scrollTop = $( window ).scrollTop();

    Object.keys( this.designsEl ).map( ( index ) => {
      const el = this.designsEl[ index ];

      if ( Utils.isOnScreen( $( el ) ) ) {
        const firstTop = $( el ).offset().top;
        const key = parseFloat( el.dataset.index );
        const depth = parseFloat( el.dataset.depth ) * key;

        const winScrollTop = ( scrollTop * depth );
        const shiftDistance = ( firstTop - winScrollTop ) * 0.08;

        let translate3d = 'translateY(' + shiftDistance + 'px)';
        if ( el.dataset.parallax == 'rotate' ) {
          translate3d = 'rotate(' + (winScrollTop / 10) + 'deg)';
          el.querySelector( '.design' ).style.transform = translate3d;
        } else {
          el.style.transform = translate3d;
        }

      }
    })

  },

}



// WEBPACK FOOTER //
// ./scripts/modules/parallax.js